const tabs = {
    platform_settings: 'การตั้งค่าแพลตฟอร์ม',
    actions: 'Actions',
    get_started: 'เริ่มต้นใช้งาน',
    dashboard: 'แดชบอร์ด',
    applications: 'แอปพลิเคชัน',
    api_resources: 'API ทรัพยากร',
    sign_in_experience: 'การเข้าสู่ระบบและบัญชี',
    connectors: 'ตัวเชื่อมต่อ',
    enterprise_sso: 'SSO สำหรับองค์กร',
    security: 'ความปลอดภัย',
    webhooks: 'Webhooks',
    organizations: 'องค์กร',
    users: 'จัดการผู้ใช้',
    audit_logs: 'บันทึกการตรวจสอบ',
    roles: 'บทบาท',
    docs: 'เอกสาร',
    tenant_settings: 'การตั้งค่า',
    mfa: 'การยืนยันตัวตนสองชั้น',
    customize_jwt: 'กำหนดค่า JWT',
    signing_keys: 'คีย์ลงนาม',
    organization_template: 'แม่แบบองค์กร',
};
export default Object.freeze(tabs);
